import React, { useState } from "react";
import axios from "../../utils/axiosConfig";
import { useLookup } from "../../utils/useLookup";
import { formatReportDate } from "../../utils/reportDate";
import "./LegacyReports.css";

const MONTHS = ["Yearly", "January", "February", "March", "April", "May", "June",
  "July", "August", "September", "October", "November", "December"];
const fmtDate = formatReportDate;
const fmt = (v, d = 2) => Number(v || 0).toLocaleString("en-IN", { minimumFractionDigits: d, maximumFractionDigits: d });

const CommissionReport = () => {
  const { suppliers, currencies } = useLookup();
  const [shipperId, setShipperId] = useState("");
  const [month, setMonth] = useState("Yearly");
  const [currency, setCurrency] = useState("USD");
  const [report, setReport] = useState(null);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const generate = async () => {
    try {
      setLoading(true); setError("");
      const res = await axios.post("/report/commission", { shipperId: shipperId || null, month, currency });
      setReport(res.data);
    } catch (err) { setError(err.response?.data?.message || "Failed to generate report."); }
    finally { setLoading(false); }
  };

  return (
    <div className="container-fluid mt-3">
      <div className="card shadow-sm border-0 no-print">
        <div className="card-header bg-white"><span className="badge bg-success fs-6 px-3 py-2">Commission Report</span></div>
        <div className="card-body"><div className="border rounded p-3 bg-light report-filter">
          <h6>Generate Monthly Commission Report</h6>
          <div className="row mb-2"><label className="col-sm-2 text-end">Supplier Name :</label><div className="col-sm-4">
            <select className="form-select form-select-sm" value={shipperId} onChange={e => setShipperId(e.target.value)}>
              <option value="">Select Supplier</option>{suppliers.map(x => <option key={x.ShipperID} value={x.ShipperID}>{x.ShipperName}</option>)}
            </select>
          </div></div>
          <div className="row mb-2"><label className="col-sm-2 text-end">Month :</label><div className="col-sm-3">
            <select className="form-select form-select-sm" value={month} onChange={e => setMonth(e.target.value)}>{MONTHS.map(x => <option key={x}>{x}</option>)}</select>
          </div></div>
          <div className="row mb-2"><label className="col-sm-2 text-end">Currency :</label><div className="col-sm-2">
            <select className="form-select form-select-sm" value={currency} onChange={e => setCurrency(e.target.value)}>
              {(currencies.length ? currencies : [{ Currency_Id: 1, Code: "USD" }]).map(x => <option key={x.Currency_Id} value={x.Code}>{x.Code}</option>)}
            </select>
          </div></div>
          {error && <div className="alert alert-danger py-2">{error}</div>}
          <div className="row"><div className="col-sm-8 offset-sm-2 d-flex gap-2">
            <button className="btn btn-success btn-sm px-4" onClick={generate} disabled={loading}>{loading ? "Generating..." : "Generate"}</button>
            {report && <button className="btn btn-outline-secondary btn-sm px-4" onClick={() => window.print()}>Print / Save PDF</button>}
          </div></div>
        </div></div>
      </div>

      {report && <section className="legacy-report mt-3">
        <ReportHeader company={report.company} title="Commission Report" />
        <div className="report-meta"><span><b>Period:</b> {report.criteria.period}</span><span><b>Currency:</b> {report.criteria.currency}</span><span><b>Generated:</b> {fmtDate(report.criteria.generatedAt)}</span></div>
        {!report.suppliers.length ? <div className="report-empty">No records found.</div> : report.suppliers.map(group => <article className="report-group" key={group.shipperId || group.shipperName}>
          <div className="report-group-title"><b>Supplier: {group.shipperName}</b><span>Total Commission: {fmt(group.totalCommission)} {currency}</span></div>
          <table className="legacy-report-table"><thead><tr><th>#</th><th>Deal</th><th>Date</th><th>Buyer</th><th>S.C No</th><th>Containers</th><th>Weight</th><th>Type</th><th>Rate / Lumpsum</th><th>Buyer Commission</th><th>Supplier Commission</th><th>Total Commission</th></tr></thead>
            <tbody>{group.rows.map((r, i) => <tr key={`${r.CommissionID || "deal"}-${r.DealID}-${i}`}><td>{i + 1}</td><td>{r.DealID}</td><td>{fmtDate(r.DealDate)}</td><td>{r.BuyerName || "-"}</td><td>{r.SCNo || "-"}</td><td className="num">{fmt(r.NoOfContainer, 0)}</td><td className="num">{fmt(r.Weight, 3)}</td><td>{r.CommissionType}</td><td className="num">{r.CommissionType === "Lumpsum" ? fmt(r.Lumpsum) : `${fmt(r.CommissionPct, 4)}${r.IsPercent ? "%" : "/T"}`}</td><td className="num">{fmt(r.BuyerCommissionAmount)}</td><td className="num">{fmt(r.SupplierCommissionAmount)}</td><td className="num">{fmt(r.TotalCommission)}</td></tr>)}</tbody>
          </table>
        </article>)}
        <div className="report-total"><b>Grand Total</b><span>Suppliers: {report.totals.suppliers}</span><span>Deals: {report.totals.deals}</span><span>Weight: {fmt(report.totals.weight, 3)}</span><span>Commission: {fmt(report.totals.commission)} {currency}</span></div>
      </section>}
    </div>
  );
};

const ReportHeader = ({ company, title }) => {
  return <header className="legacy-report-header"><h1>{company.CompanyName || "Global Metals"}</h1><h2>{title}</h2></header>;
};

export default CommissionReport;
